import { Injectable, signal } from '@angular/core';

/** Shows the app-shell export spinner while an export download runs. */
@Injectable({ providedIn: 'root' })
export class ExportLoaderService {
  readonly visible = signal(false);

  private running = false;

  async run(task: () => Promise<void>): Promise<void> {
    if (this.running) return;
    this.running = true;
    this.visible.set(true);
    try {
      await task();
    } finally {
      this.visible.set(false);
      this.running = false;
    }
  }
}
